module.exports = {
  src: __webpack_public_path__ + "assets/images/edit-icon.bb130cfb0ceed604.svg",
  width: 11,
  height: 11,
  toString: function() { return __webpack_public_path__ + "assets/images/edit-icon.bb130cfb0ceed604.svg"; }
};